import { UPDATE_WIZARD, CLEAR_WIZARD, REMOVE_DATA_KEY_WIZARD } from "../actions/WizardActions";
const INITIAL_STATE = {};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_WIZARD:
      {
        const newState = {
          ...state[action.payload.name],
          ...action.payload.value
        };
        return {
          ...state,
          [action.payload.name]: newState
        };
      }
    case CLEAR_WIZARD:
      {
        const newState = {
          ...state
        };
        delete newState[action.payload];
        return newState;
      }
    case REMOVE_DATA_KEY_WIZARD:
      {
        const newState = {
          ...state
        };
        delete newState[action.payload.name][action.payload.dataKey];
        return newState;
      }
    default:
      return state;
  }
};